// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Roboto !important;
}

.commPara_commHeading {
  color: #fff;
  text-align: center;
  font-size: 3vw;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  margin-top: 6vw;
}
@media (max-width: 1300px) {
  .commPara_commHeading {
    font-size: 3.3vw;
    line-height: 150%;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 576px) {
  .commPara_commHeading {
    font-size: 6vw;
    margin-top: 10vw;
    line-height: 150%;
    margin-left: 2vw;
    margin-right: 2vw;
  }
}
.commPara_subHeading {
  text-align: center;
  margin-top: 3vw;
  color: #fff;
  font-size: 2vw;
  font-style: normal;
  font-weight: 500;
  line-height: 100%; /* 30px */
}
@media (max-width: 1300px) {
  .commPara_subHeading {
    font-size: 3.3vw;
    line-height: 150%;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 576px) {
  .commPara_subHeading {
    font-size: 6vw;
    margin-top: 10vw;
    line-height: 150%;
    margin-left: 2vw;
    margin-right: 2vw;
  }
}
.commPara_paraCom {
  color: #fff;
  text-align: center;
  font-size: 1.1vw;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: 1.5vw;
}
@media (max-width: 1300px) {
  .commPara_paraCom {
    font-size: 1.7vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 992px) {
  .commPara_paraCom {
    font-size: 2vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 769px) {
  .commPara_paraCom {
    font-size: 2.5vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 576px) {
  .commPara_paraCom {
    font-size: 4vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
.commPara_paraCom1 {
  color: #fff;
  margin-top: 0.5vw;
  text-align: center;
  font-size: 1.1vw;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
@media (max-width: 1300px) {
  .commPara_paraCom1 {
    font-size: 1.7vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 992px) {
  .commPara_paraCom1 {
    font-size: 2vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 769px) {
  .commPara_paraCom1 {
    font-size: 2.5vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 576px) {
  .commPara_paraCom1 {
    font-size: 4vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
.commPara_paraCom2 {
  color: #fff;
  margin-top: 0.5vw;
  text-align: center;
  font-size: 1.1vw;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
@media (max-width: 1300px) {
  .commPara_paraCom2 {
    font-size: 1.7vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 992px) {
  .commPara_paraCom2 {
    font-size: 2vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 769px) {
  .commPara_paraCom2 {
    font-size: 2.5vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 576px) {
  .commPara_paraCom2 {
    font-size: 4vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
.commPara_paraCom3 {
  color: #fff;
  margin-top: 0.5vw;
  text-align: center;
  font-size: 1.1vw;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding-left: 5.5vw;
  padding-right: 5.5vw;
}
@media (max-width: 1300px) {
  .commPara_paraCom3 {
    font-size: 1.7vw;
  }
}
@media (max-width: 992px) {
  .commPara_paraCom3 {
    font-size: 2vw;
  }
}
@media (max-width: 769px) {
  .commPara_paraCom3 {
    font-size: 2.5vw;
  }
}
@media (max-width: 576px) {
  .commPara_paraCom3 {
    font-size: 4vw;
  }
}
.commPara_paraCom4 {
  color: #fff;
  margin-top: 0.5vw;
  text-align: center;
  font-size: 1.1vw;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding-left: 5.5vw;
  padding-right: 5.5vw;
}
@media (max-width: 1300px) {
  .commPara_paraCom4 {
    font-size: 1.7vw;
  }
}
@media (max-width: 992px) {
  .commPara_paraCom4 {
    font-size: 2vw;
  }
}
@media (max-width: 769px) {
  .commPara_paraCom4 {
    font-size: 2.5vw;
  }
}
@media (max-width: 576px) {
  .commPara_paraCom4 {
    font-size: 4vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/CommonPara/commonPara.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;AACF;;AAEE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AACJ;AAAI;EARF;IASI,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,oBAAA;EAGJ;AACF;AAFI;EAdF;IAeI,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;EAKJ;AACF;AAHE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAKJ;AAJI;EARF;IASI,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,oBAAA;EAOJ;AACF;AANI;EAdF;IAeI,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;EASJ;AACF;AAPE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AASJ;AARI;EARF;IASI,gBAAA;IACA,mBAAA;IACA,oBAAA;EAWJ;AACF;AAVI;EAbF;IAcI,cAAA;IACA,mBAAA;IACA,oBAAA;EAaJ;AACF;AAZI;EAlBF;IAmBI,gBAAA;IACA,mBAAA;IACA,oBAAA;EAeJ;AACF;AAdI;EAvBF;IAwBI,cAAA;IACA,mBAAA;IACA,oBAAA;EAiBJ;AACF;AAfE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAiBJ;AAhBI;EARF;IASI,gBAAA;IACA,mBAAA;IACA,oBAAA;EAmBJ;AACF;AAlBI;EAbF;IAcI,cAAA;IACA,mBAAA;IACA,oBAAA;EAqBJ;AACF;AApBI;EAlBF;IAmBI,gBAAA;IACA,mBAAA;IACA,oBAAA;EAuBJ;AACF;AAtBI;EAvBF;IAwBI,cAAA;IACA,mBAAA;IACA,oBAAA;EAyBJ;AACF;AAvBE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAyBJ;AAxBI;EARF;IASI,gBAAA;IACA,mBAAA;IACA,oBAAA;EA2BJ;AACF;AA1BI;EAbF;IAcI,cAAA;IACA,mBAAA;IACA,oBAAA;EA6BJ;AACF;AA5BI;EAlBF;IAmBI,gBAAA;IACA,mBAAA;IACA,oBAAA;EA+BJ;AACF;AA9BI;EAvBF;IAwBI,cAAA;IACA,mBAAA;IACA,oBAAA;EAiCJ;AACF;AA/BE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;AAiCJ;AAhCI;EAVF;IAWI,gBAAA;EAmCJ;AACF;AAlCI;EAbF;IAcI,cAAA;EAqCJ;AACF;AApCI;EAhBF;IAiBI,gBAAA;EAuCJ;AACF;AAtCI;EAnBF;IAoBI,cAAA;EAyCJ;AACF;AAvCE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;AAyCJ;AAxCI;EAVF;IAWI,gBAAA;EA2CJ;AACF;AA1CI;EAbF;IAcI,cAAA;EA6CJ;AACF;AA5CI;EAhBF;IAiBI,gBAAA;EA+CJ;AACF;AA9CI;EAnBF;IAoBI,cAAA;EAiDJ;AACF","sourcesContent":["* {\n  font-family: Roboto !important;\n}\n.commPara {\n  &_commHeading {\n    color: #fff;\n    text-align: center;\n    font-size: 3vw;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 100%;\n    margin-top: 6vw;\n    @media (max-width: 1300px) {\n      font-size: 3.3vw;\n      line-height: 150%;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 6vw;\n      margin-top: 10vw;\n      line-height: 150%;\n      margin-left: 2vw;\n      margin-right: 2vw;\n    }\n  }\n  &_subHeading {\n    text-align: center;\n    margin-top: 3vw;\n    color: #fff;\n    font-size: 2vw;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 100%; /* 30px */\n    @media (max-width: 1300px) {\n      font-size: 3.3vw;\n      line-height: 150%;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 6vw;\n      margin-top: 10vw;\n      line-height: 150%;\n      margin-left: 2vw;\n      margin-right: 2vw;\n    }\n  }\n  &_paraCom {\n    color: #fff;\n    text-align: center;\n    font-size: 1.1vw;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    margin-top: 1.5vw;\n    @media (max-width: 1300px) {\n      font-size: 1.7vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 992px) {\n      font-size: 2vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 769px) {\n      font-size: 2.5vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 4vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n  }\n  &_paraCom1 {\n    color: #fff;\n    margin-top: 0.5vw;\n    text-align: center;\n    font-size: 1.1vw;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    @media (max-width: 1300px) {\n      font-size: 1.7vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 992px) {\n      font-size: 2vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 769px) {\n      font-size: 2.5vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 4vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n  }\n  &_paraCom2 {\n    color: #fff;\n    margin-top: 0.5vw;\n    text-align: center;\n    font-size: 1.1vw;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    @media (max-width: 1300px) {\n      font-size: 1.7vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 992px) {\n      font-size: 2vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 769px) {\n      font-size: 2.5vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 4vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n  }\n  &_paraCom3 {\n    color: #fff;\n    margin-top: 0.5vw;\n    text-align: center;\n    font-size: 1.1vw;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    padding-left: 5.5vw;\n    padding-right: 5.5vw;\n    @media (max-width: 1300px) {\n      font-size: 1.7vw;\n    }\n    @media (max-width: 992px) {\n      font-size: 2vw;\n    }\n    @media (max-width: 769px) {\n      font-size: 2.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 4vw;\n    }\n  }\n  &_paraCom4 {\n    color: #fff;\n    margin-top: 0.5vw;\n    text-align: center;\n    font-size: 1.1vw;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    padding-left: 5.5vw;\n    padding-right: 5.5vw;\n    @media (max-width: 1300px) {\n      font-size: 1.7vw;\n    }\n    @media (max-width: 992px) {\n      font-size: 2vw;\n    }\n    @media (max-width: 769px) {\n      font-size: 2.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 4vw;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
